"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConsultationCTA() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="consultationcta" className="w-full py-6 md:py-8 lg:py-10 bg-background flex items-center justify-start overflow-hidden">
      <div ref={ref} className={`container px-4 md:px-6 max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col items-start gap-2">
          <Button asChild className="h-auto py-3 px-6 rounded-2xl md:rounded-3xl bg-[var(--color-green-accent)] hover:bg-[var(--color-green-accent)]/90 text-white shadow-xl hover:shadow-2xl transition-all duration-300 group border-none">
            <Link to="https://booking.mangomint.com/moselfcare/virtualwellnessconsultation" newTab className="flex items-center justify-center gap-3 w-full">
              <div className="flex flex-col items-start">
                <span className="text-xs md:text-sm font-default font-semibold tracking-wide flex items-center gap-2">
                  REQUEST CONSULTATION
                  <ArrowRight className="w-3 h-3 md:w-4 md:h-4 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
                <span className="text-[10px] md:text-xs opacity-90 font-default tracking-wide">
                  In Person & Virtual
                </span>
              </div>
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}